module.exports = __webpack_public_path__ + "assets/img/gal_02.7df46e30.jpg";